<app-feature-hero
    title="CMDB software"
    description="The best CMDB software for managing your infrastructure"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-hero-img-01.svg"
    imageAlt="CMDB Software Hero Image"
></app-feature-hero>


<app-feature-row
    headingLevel="h2"
    heading="What is CMDB Software?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-feature-img-1-01.webp"
    imageAlt="hardware asset management"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="CMDB software typically provides a variety of features to help organizations manage their IT assets, including"
    [paragraphs]="featuresParagraphs"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-feature-img-2-01.svg"
    imageAlt="hardware asset management"
    imagePosition="right"
></app-feature-row>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">Key Benefits of CMDB Software</h2>

<app-feature-row
    headingLevel="h3"
    heading="Improved visibility and control"
    [paragraphs]="visibilityParagraph"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-feature-img-3-01.png"
    imageAlt="Infraon Assets Dashboard"
    imagePosition="right"
></app-feature-row>
    
<app-feature-row
    headingLevel="h3"
    heading="Automate asset management processes"
    [paragraphs]="automateParagraph"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-feature-img-4-01.png"
    imageAlt="Disc Memory"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Reduce the cost of asset management"
    [paragraphs]="reduceCostParagraph"
    image="/assets/img/feature-pages/infraon-assets/cmdb/qr-code-feature-img-3-01.png"
    imageAlt="Maintenance cost"
    imagePosition="right"
></app-feature-row>
    
<app-feature-row
    headingLevel="h3"
    heading="Improved efficiency"
    [paragraphs]="improvedEfficiencyParagraph"
    image="/assets/img/feature-pages/infraon-assets/cmdb/qr-code-feature-img-2-01.png"
    imageAlt="Device discovery charts"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Enhanced compliance"
    [paragraphs]="enhancedComplianceParagraph"
    image="/assets/img/feature-pages/infraon-assets/cmdb/cmdb-feature-img-7-01.png"
    imageAlt="Analysis Dashboard"
    imagePosition="right"
></app-feature-row>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">Feature Highlights</h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M12.25 22.75H19.25V36.75H12.25V22.75ZM36.75 15.75V36.75H29.75V15.75H36.75Z" fill="#084CD4"/><path d="M21 12H28V36.7043H21V12Z" fill="#A8C1F1"/></svg>
                <h3 class="section-title-s text-start">Centralized asset repository</h3>
                <p class="section-paragraph text-start">Provides a single source of truth for all IT asset data</p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M10.5 22.75V33.25H7V22.75H10.5ZM42 22.75V33.25H38.5V22.75H42Z" fill="#A8C1F1"/><path d="M26 10V11.75V15.25H36.5V38H12V15.25H22.5V11.75V10H26ZM21.1875 24C21.1875 22.7969 20.2031 21.8125 19 21.8125C17.7422 21.8125 16.8125 22.7969 16.8125 24C16.8125 25.2578 17.7422 26.1875 19 26.1875C20.2031 26.1875 21.1875 25.2578 21.1875 24ZM29.5 26.1875C30.7031 26.1875 31.6875 25.2578 31.6875 24C31.6875 22.7969 30.7031 21.8125 29.5 21.8125C28.2422 21.8125 27.3125 22.7969 27.3125 24C27.3125 25.2578 28.2422 26.1875 29.5 26.1875Z" fill="#084CD4"/><rect x="17" y="31" width="14" height="2" rx="1" fill="#A8C0F1"/></svg>
                <h3 class="section-title-s text-start">Automated IT processes</h3>
                <p class="section-paragraph text-start">Streamlines IT asset management processes and improves efficiency</p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="18" y="18" width="14" height="17" fill="#A8C1F1"/><path d="M14.875 36.75H7V28.875C7 25.4844 9.1875 22.5312 12.25 21.4922V21C12.25 16.1875 16.1328 12.25 21 12.25C24.2266 12.25 27.0703 14.0547 28.5469 16.6797C29.3672 16.0781 30.4062 15.75 31.5 15.75C34.3984 15.75 36.75 18.1016 36.75 21V22.9688C39.7578 23.7891 42 26.5234 42 29.75V36.75H35H14.875ZM19.1953 24.8828L18.2656 25.8125L20.125 27.6719L21.0547 26.7422L23.1875 24.6094V31.9375V33.25H25.8125V31.9375V24.6094L27.9453 26.7422L28.875 27.6719L30.6797 25.8125L29.75 24.8828L25.375 20.5078L24.4453 19.5781L23.5156 20.5078L19.1406 24.8828H19.1953Z" fill="#084CD4"/></svg>
                <h3 class="section-title-s text-start">Third-party integration</h3>
                <p class="section-paragraph text-start">Easily imports and exports data and synchronizes data between different systems</p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M22.75 18.375C22.75 14.0547 26.25 10.5 30.625 10.5C31.6641 10.5 32.6484 10.7188 33.5234 11.1016L28.875 15.75V20.125H33.25L37.8984 15.4766C38.2812 16.3516 38.5 17.3359 38.5 18.375C38.5 21.7656 36.3672 24.6094 33.4141 25.7578L30.9531 23.2969L29.75 22.0391L28.4922 23.2969L28.0547 23.7344L22.75 18.4297V18.375ZM10.5 33.25L19.6875 24.0625L23.6797 28.0547L23.2422 28.5469L21.9844 29.75L23.2422 31.0078L15.75 38.5L10.5 33.25ZM17.9922 32.8125L16.1875 31.0078L14.3281 32.8125L16.1875 34.6719L17.9922 32.8125Z" fill="#084CD4"/><path d="M26.6953 28.5547L19.6406 21.5H16.25L11 14.5L14.5 11L21.5 16.25V19.6953L28.5547 26.6953L30.25 25L39 33.75L33.75 39L25 30.25L26.6953 28.5547Z" fill="#A8C1F1"/></svg>
                <h3 class="section-title-s text-start">CMDB discovery tools</h3>
                <p class="section-paragraph text-start">Helps to discover and track the relationships between IT infrastructure components</p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M13.4453 16.6797C16.0156 14.2734 19.5703 12.25 24 12.25C28.375 12.25 31.9297 14.2734 34.5 16.6797C37.0703 19.0312 38.7656 21.875 39.5859 23.8438C39.75 24.2812 39.75 24.7734 39.5859 25.2109C38.7656 27.125 37.0703 29.9688 34.5 32.375C31.9297 34.7812 28.375 36.75 24 36.75C19.5703 36.75 16.0156 34.7812 13.4453 32.375C10.875 29.9688 9.17969 27.125 8.35938 25.2109C8.19531 24.7734 8.19531 24.2812 8.35938 23.8438C9.17969 21.875 10.875 19.0312 13.4453 16.6797Z" fill="#084CD4"/><path d="M17 24C17 20.1719 20.1172 17 24 17C27.8281 17 31 20.1719 31 24C31 27.8828 27.8281 31 24 31C20.1172 31 17 27.8828 17 24ZM24 28.375C26.4062 28.375 28.375 26.4609 28.375 24C28.375 21.5938 26.4062 19.625 24 19.625C23.9453 19.625 23.8906 19.625 23.8359 19.625C23.9453 19.9531 24 20.2266 24 20.5C24 22.4688 22.4141 24 20.5 24C20.1719 24 19.8984 24 19.625 23.8906C19.625 23.9453 19.625 24 19.625 24C19.625 26.4609 21.5391 28.375 24 28.375Z" fill="#A8C1F1"/></svg>
                <h3 class="section-title-s text-start">Reporting and Visualization</h3>
                <p class="section-paragraph text-start">Illustrate, inquire, and comprehend intricate configuration item (CI) relationships across tables through a transparent and graphical perspective.</p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><rect x="10" y="11" width="29" height="16" fill="#A8C1F1"/><path d="M40.25 9.5V32.25H27.125L27.6719 34H31.5H33.25V37.5H31.5H17.5H15.75V34H17.5H21.2734L21.875 32.25H8.75V9.5H40.25ZM36.75 13H12.25V25.25H36.75V13Z" fill="#084CD4"/></svg>
                <h3 class="section-title-s text-start">CMDB Hub</h3>
                <p class="section-paragraph text-start">Make use of a centralized tool to monitor activity, check the CMDB's health, and conduct natural language searches.</p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        IT asset management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to optimize your IT asset usage. Make smart purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Software asset management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to optimize your IT asset usage. Make smart purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-license-management">
                <div class="backlink-container bg-white px-5 py-4 h-100">
                    <p class="section-title-s text-start">
                        Software Licensing management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon Assets helps you manage the lifecycles of fixed assets like PCs, laptops, furniture, storage devices, etc., with a 360-degree view...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>